import { bootstrapApp } from "./app";

const appEl = document.getElementById("app");
if (!appEl) {
  throw new Error("Brak elementu #app w index.html");
}

bootstrapApp(appEl);
